import React from "react";
import AudioPlayer from "components/AudioPlayer";
import VideoPlayer from "components/VideoPlayer";
import ImageContainer from "components/ImageContainer/ImageContainer";
import MediaPreview from "components/MediaPreview/MediaPreview";
import Linkify from "react-linkify";

export default ({ post }) => {
  return (
    <div>
      {post?.data?.content && (
        <Linkify
          properties={{
            target: "_blank",
            style: { color: "red", fontWeight: "bold" },
          }}
        >
          <p
            className="textContent customScrollArea"
            style={{ maxHeight: "200px", overflow: "auto" }}
          >
            {post.data.content}
          </p>
        </Linkify>
      )}
      {post?.data?.media_type_id === 4 && (
        <AudioPlayer src={post?.data?.media} />
      )}
      {post?.data?.media_type_id === 3 && (
        <VideoPlayer src={post?.data?.media} />
      )}
      {post?.data?.media_type_id === 2 && (
        <MediaPreview
          attachment={post?.data?.media}
          type={post?.data?.media_type}
        >
          <ImageContainer
            src={post?.data?.media}
            thumb={post?.data?.media}
            alt={post?.data?.media_type}
          />
        </MediaPreview>
      )}
    </div>
  );
};
